export enum FilterDateType {
    RANGE = 'range',
    SPECIFIC = 'specific'
}
